/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { ICategory } from "web/types/Category";
import type { Nullable } from "web/types/Utils";

const processCategoryTree = (
  categoriesTree: string[] | undefined,
  categoriesData: ICategory[],
  startCategoryId: Nullable<number>
): ICategory[] => {
  const initialStartCategoryId = startCategoryId === 2 ? null : startCategoryId;

  return (
    categoriesTree?.reduce<ICategory[]>((result, path) => {
      switch (true) {
        case !!initialStartCategoryId: {
          const startCategoryIdStringBegin = `${startCategoryId}/`;
          const startCategoryIdStringMiddle = `/${startCategoryId}/`;

          let pathSliced: string;
          if (path.indexOf(startCategoryIdStringBegin) === 0) {
            pathSliced = path.slice(startCategoryIdStringBegin.length);
          }

          if (path.indexOf(startCategoryIdStringMiddle) !== -1) {
            pathSliced = path.slice(
              path.indexOf(startCategoryIdStringMiddle) +
                startCategoryIdStringMiddle.length
            );
          }

          // @ts-ignore
          if (pathSliced?.length) {
            const idChild = parseInt(pathSliced, 10);
            const categoryDataChild =
              idChild &&
              categoriesData.find(
                (category) => category && +category.id === +idChild
              );
            return categoryDataChild ? [...result, categoryDataChild] : result;
          }

          return result;
        }
        case path.indexOf("/") === -1: {
          const categoryData = categoriesData.find(
            (category) => category && +category.id === +path
          );
          return categoryData ? [...result, categoryData] : result;
        }
        default: {
          return result;
        }
      }
    }, []) || []
  );
};

export default processCategoryTree;
